import SectionHeading from "./SectionHeading";
import AnimeCard from "@/components/feature/AnimeCard";
import { hotAnime } from "@/mocks/anime";

export default function HotSection() {
  return (
    <section id="hot" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeading
          eyebrow="本季热度排行"
          title="热门全集榜"
          desc="按下周更新节奏与讨论热度综合排列，标注连载与完结状态，评分与集数为示例数据，方便你快速判断要不要开坑。"
        />
        <a
          href="#genre"
          className="inline-flex shrink-0 items-center gap-1.5 self-start whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 lg:self-auto cursor-pointer"
        >
          按类型筛选更多
          <i className="ri-arrow-right-line" />
        </a>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 md:gap-5 lg:grid-cols-4">
        {hotAnime.map((item, index) => (
          <AnimeCard key={item.id} item={item} rank={index + 1} />
        ))}
      </div>
    </section>
  );
}